<template>
  <div class="banner-container" ref="banner">
    <!-- banner -->
    <div class="banner__wap-container">
      <div class="img"> <img src ="../assets/wrap-img/banner.svg"  /> </div>
      <div class="banner__title">
          <div v-for="(i,k) in title" :key="k">{{i.text}} </div>
      </div>
     <!-- <div class="test">昊雨科技，助您智造未来！</div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Banner',

  data () {
    return {
      title:[
        {text:'昊雨科技，助您智造未来！'},
        {text:'Haoyu Technology'},
      ]
    }
  }
}
</script>
<style scoped lang="scss" vars="{ zoom }">
@import '../assets/css/function.scss';

.wrap{
 
  .banner-container{
    position: relative;
    // border:1px solid red;
    .img{
      img{
        width:100%;
         display: block;
      }
    }
    .banner__title{
      color:#fff;
      font-size:f(52);
      font-family: ArialMT;
      // border:1px solid green;
      position:absolute;
      top:26.95%;
      left:10.4%;
    };
    .test{
      color:#fff;
      font-size:f(52);
      font-family: ArialMT;
      border:1px solid green;
      position:absolute;
      bottom:3px;
    }
    
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Banner.vue